import { Address } from "./Address";

export class User{
    id: number;
    version: number;
    accountId: number;
    firstName: string;
    lastName: string;
    nid: string;
    lockout: string;
    status: string;
    oldPassword: string;
    lastHostname: string;
    lastChange: Date;
    lastLogin: Date;
    lastFailed: Date;
    expiration: Date;
    failed: number;
    email: string;
    creationDate: Date;
    connected: boolean;
    active: boolean;
    token: string;
    phone: string;    
    role: {
        id: number;
        name: string;
    }[];
    addresses: Address[];
}